import(/* webpackMode: "eager" */ "/codebuild/output/src2276691906/src/doctor-dashboard/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2276691906/src/doctor-dashboard/src/components/loader/SplashScreenLoader.tsx");
